import { useContext, useEffect } from 'react'
import cn from 'classnames'

import { deleteUserBookmark, saveUserBookmark } from '../common/api/Bookmarks'
import CourseContext from '../common/contexts/CourseContext'

export default function Bookmark({
  category,
  categoryObjectId,
  size = 'fs-6',
  color = 'text-white',
  className = ''
}) {
  const { bookmarks, setBookmarks } = useContext(CourseContext)

  /**
   * Helper function to determine whether there's a bookmark
   */
  const hasBookmark = bookmark =>
    bookmark.category_object_id === parseInt(categoryObjectId) &&
    bookmark.category === category

  /**
   * Helper function to save the bookmark after clicking on the bookmark sign
   */
  const handleBookmarkClick = async () => {
    const bookmark = bookmarks?.find(hasBookmark)

    // If we have a bookmark, delete it
    if (bookmark) {
      const success = await deleteUserBookmark(bookmark.id)
      if (success) {
        const updated = bookmarks.filter(item => item !== bookmark)
        setBookmarks(updated)
      }
      return success
    }

    // Otherwise, save it
    const saveResult = await saveUserBookmark({
      category_object_id: categoryObjectId,
      category
    })

    // Did we get a result?
    if (!saveResult.category) return null

    const updated = bookmarks.concat([saveResult])

    setBookmarks(updated)
    return saveResult
  }

  // Add an effect to update the bookmark state when the bookmarks change
  useEffect(() => {}, [bookmarks])

  // Return early if we don't have a category or categoryObjectId
  if (!category || !categoryObjectId) return null

  return (
    <button
      className={cn('bg-transparent border-0 bookmark-button', className)}
    >
      <i
        onClick={_ => handleBookmarkClick()}
        className={cn(
          'bi bookmark',
          color,
          size,
          bookmarks?.some(hasBookmark) ? 'bi-bookmark-fill' : 'bi-bookmark-plus'
        )}
      />
    </button>
  )
}
